












































































































import Vue from 'vue';
import Modal from '../components/common/Modal/Modal.vue';
import Input from '../components/common/Input/Input.vue';
import NotificationText from '../components/common/NotificationText/NotificationText.vue';
import TextArea from '../components/common/TextArea/TextArea.vue';
import Button from '../components/common/Button/Button.vue';
import Select from '../components/common/Select/CustomSelect.vue';
import Checkbox from '../components/common/CheckBox/CheckBox.vue';
import ImageSetCreate from '../components/DatasetCreateView/ImageSetCreate.vue';
import NoneSetCreate from '../components/DatasetCreateView/NoneSetCreate.vue';
import TextSetCreate from '../components/DatasetCreateView/TextSetCreate.vue';
import VideoSetCreate from '../components/DatasetCreateView/VideoSetCreate.vue';
import AudioSetCreate from '@/components/DatasetCreateView/AudioSetCreate.vue';

import { axiosApiInstance } from '../utils/axiosInstances';
import {
  checkAgentAliveStatus,
  requestDatasetFileAnalysis,
} from '../utils/axiosAgentInstance';
import { AnalysisStatusI } from '../interfaces/AnalysisStatusI';
import { folderI } from '@/interfaces/folderI';
import { DatasetAnalysisRule } from '@/interfaces/types/Dataset';

export default Vue.extend({
  components: {
    Modal,
    Input,
    Button,
    NotificationText,
    TextArea,
    Select,
    ImageSetCreate,
    TextSetCreate,
    VideoSetCreate,
    NoneSetCreate,
    AudioSetCreate,
    Checkbox,
  },
  data(): {
    datasetName: string;
    datasetType: string;
    datasetDescription: string;
    datasetPath: string;
    datasetRequiredWidth?: number;
    datasetRequiredHeight?: number;
    datasetRequiredSize?: number;
    datasetRequiredDuration?: number;
    datasetRequiredSimilarity?: number;
    datasetRule?: DatasetAnalysisRule;
    datasetNameError: boolean;
    datasetTypeError: boolean;
    datasetDescriptionError: boolean;
    datasetPathError: boolean;
    datasetOptionError: boolean;
    typeMenuList: string[];
    typeMapper: { [type: string]: string };
    isOptionInvalid: boolean;
    skipMetadata: boolean;
  } {
    const typeMapper: { [type: string]: string } = {
      이미지: 'image',
      텍스트: 'text',
      // 영상: 'video',
      오디오: 'audio',
      라벨셋: 'nodata',
    };

    return {
      datasetName: '',
      datasetType: '',
      datasetDescription: '',
      datasetPath: '',
      datasetRequiredWidth: undefined,
      datasetRequiredHeight: undefined,
      datasetRequiredSize: undefined,
      datasetRequiredDuration: undefined,
      datasetRequiredSimilarity: undefined,
      datasetRule: {},
      datasetNameError: false,
      datasetTypeError: false,
      datasetDescriptionError: false,
      datasetPathError: false,
      typeMenuList: Object.keys(typeMapper),
      typeMapper: typeMapper,
      datasetOptionError: false,
      isOptionInvalid: false,
      skipMetadata: false,
    };
  },
  created() {
    this.$store.commit('startLoading');
    checkAgentAliveStatus().then(() => {
      this.$store.commit('stopLoading');
    });
  },
  methods: {
    /** 데이터셋 생성 버튼 클릭 시 호출 */
    async onClickButton() {
      this.datasetNameError = this.datasetName === '';
      this.datasetDescriptionError = this.datasetDescription === '';
      this.datasetPathError =
        this.datasetPath === '' &&
        this.typeMapper[this.datasetType] !== 'nodata';
      this.datasetTypeError = this.datasetType === '';
      this.datasetOptionError = this.isOptionInvalid;

      if (
        this.datasetNameError ||
        this.datasetDescriptionError ||
        this.datasetPathError ||
        this.datasetTypeError ||
        this.datasetOptionError
      ) {
        /** 생성 시점에서 오류 데이터 존재 시 UI 업데이트 */
        return;
      }

      /** request body 전용 type */
      type datasetCreateType = {
        name: string;
        description: string;
        target_path: string;
        type: string;
        requirement?: {
          resolution?: {
            width: number;
            height: number;
          };
          file_size?: number;
          duration?: number;
          similarity?: number;
        };
        analysis_status: AnalysisStatusI;
        analysis_rule: {
          target_ext?: string;
          target_prop?: string;
          csv_no_header?: boolean;
          similarity_analysis?: {
            per: 'folder' | 'label';
            rootPath: string;
            imagePath: string;
            labelType?: 'coco';
            labelPath?: string;
            cropPath?: string;
          };
        };
      };

      /** 생성에 사용할 POST 요청 body 객체 */
      let newDatasetSchema: datasetCreateType = {
        name: this.datasetName,
        description: this.datasetDescription,
        target_path: this.datasetPath,
        analysis_status: {
          status: 'READY',
        },
        type: this.typeMapper[this.datasetType],
        analysis_rule: {
          target_ext: this.datasetRule?.targetExt,
          target_prop: this.datasetRule?.targetProp,
          csv_no_header: this.datasetRule?.csvNoHeader,
          similarity_analysis: this.datasetRule?.similarityAnalysis,
        },
      };

      if (
        this.datasetRequiredWidth !== undefined ||
        this.datasetRequiredHeight !== undefined
      ) {
        newDatasetSchema['requirement'] = {
          ...newDatasetSchema.requirement,
          resolution: {
            width:
              this.datasetRequiredWidth === undefined
                ? 0
                : this.datasetRequiredWidth,
            height:
              this.datasetRequiredHeight === undefined
                ? 0
                : this.datasetRequiredHeight,
          },
        };
      }

      if (this.datasetRequiredSize !== undefined) {
        newDatasetSchema['requirement'] = {
          ...newDatasetSchema.requirement,
          file_size: this.datasetRequiredSize,
        };
      }

      if (this.datasetRequiredDuration !== undefined) {
        newDatasetSchema['requirement'] = {
          ...newDatasetSchema.requirement,
          duration: this.datasetRequiredDuration,
        };
      }

      if (this.datasetRequiredSimilarity !== undefined) {
        newDatasetSchema['requirement'] = {
          ...newDatasetSchema.requirement,
          // xx% => .xx
          similarity: this.datasetRequiredSimilarity / 100,
        };
      }

      console.log(newDatasetSchema['requirement']);

      /** 데이터셋 생성 전 확인
       * TBD 에러 메세지가 표시된 상황에서 다시 정상적인 값을 입력하고 생성 버튼을 누를 시,
       * 확인 창이 떠있는데 기존 에러 메세지가 남아있어 눈에 거슬림
       * onClickButton context가 confirm에서 blocking되면서 발생하는 문제
       * confirm을 promise로 wrapping하고 if문 아래 코드를 거기다가 포함시키면 될..듯..?
       * critical한 문제는 아니라서 tbd
       */
      if (!confirm('데이터셋을 생성하시겠습니까?')) return;

      const workspaceId =
        this.$route.path.split('/')[this.$route.path.split('/').length - 1];

      try {
        this.$store.commit('startLoading');
        /** Dataset 생성 코드, TBD axios call util 모듈로 분리 */
        const backendResponse = await axiosApiInstance.post(
          `/api/v1/workspaces/${workspaceId}/datasets`,
          newDatasetSchema,
        );

        if (backendResponse.status === 201) {
          const datasetId = backendResponse.data.result.dataset_id;

          try {
            await requestDatasetFileAnalysis(datasetId, this.skipMetadata);

            this.$emit('updateFolderList', {
              id: backendResponse.data.result.dataset_id,
              name: backendResponse.data.result.name,
              description: backendResponse.data.result.description,
              analysisStatus: backendResponse.data.result.analysis_status,
            } as folderI);
          } catch (analysisError) {
            /** 분석 agent 생성 중 에러 발생 */
            console.error(analysisError);

            const errorPatchResponse = await axiosApiInstance.patch(
              `/api/v1/datasets/${datasetId}`,
              {
                analysis_status: {
                  status: 'ERROR',
                  error_code: 'UNDEFINED',
                  error_message: (analysisError as Error).message,
                },
              },
            );

            this.$emit('updateFolderList', {
              id: errorPatchResponse.data.result.dataset_id,
              name: errorPatchResponse.data.result.name,
              description: errorPatchResponse.data.result.description,
              analysisStatus: errorPatchResponse.data.result.analysis_status,
            } as folderI);
          }
        } else {
          console.error(backendResponse.status);
          console.error(backendResponse.statusText);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.$emit('closeModal');
        this.$store.commit('stopLoading');
      }
    },
  },
});
